/* global BMS */
import React, {Component} from 'react';
import {connect} from 'react-redux';
// style
import style from '../css/helpPageScreen.css';
import {ASSETS_URL, HELP_PAGES_URL} from "../../../constants/endpoints";
import {BET_LIMITS} from "../../../constants/betLimits";
import {BASE_VALUE} from '../../../constants/chips';
import {getFormattedCurrency, usingNonDecimalCurrency} from "../../../helpers/localization";
import {PLACE, SHOW, SUPPORTED_RACING_MARKETS, TO_WIN_EW} from '../modules/racing/constants/identifiers';
import {OPERATOR} from '../../../constants/operator';
import {VIRTUALS} from "../../../constants/games";

let helpContentId = 'helpContent';

const mapStateToProps = (state, ownProps) => {
    return {
        isModalOpen: state.vpp.isModalOpen,
        openModalType: state.vpp.openModalType,
    };
};

class HelpPageScreen extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState().vpp;

        this.state = {
            isModalOpen: storeData.isModalOpen,
            openModalType: storeData.openModalType,
            pagesJson: undefined,
            pageHtml: undefined,
            pageSelectedIndex: 0,
            isScrollTopButtonVisible: false
        };

        fetch(HELP_PAGES_URL + 'index.json')
            .then(response => response.json())
            .then(data => {
                this.setState({pagesJson: data})
                return fetch(HELP_PAGES_URL + data.localizationFolders[storeData.systemLanguage] + "/" + data.fileNames[this.state.pageSelectedIndex].fileName)
            })
            .then(response => response.text())
            .then(data => this.setState({pageHtml: this._replaceValues(data)}))
            .catch((error) => console.log('Error retrieving help pages index.', error));

    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        this.setState(
            {
                isModalOpen: storeData.vpp.isModalOpen,
                openModalType: storeData.vpp.openModalType,
            }
        );
    }

    componentDidMount() {
        document.getElementById(helpContentId).addEventListener("scroll", this._scrollHandler.bind(this));
    }

    componentWillUnmount() {
        document.getElementById(helpContentId).removeEventListener("scroll", this._scrollHandler.bind(this));
    }

    _scrollTopButtonClickHandler(e) {
        document.getElementById(helpContentId).scrollTop = 0;
    }

    _replaceValues(data) {
        let systemCurrency = this.props.store.getState().vpp.systemCurrency;
        data = data.replace(/{minBet}/g, getFormattedCurrency(this.props.store, (usingNonDecimalCurrency(systemCurrency) ? this._scaleNumber(Number(BET_LIMITS.minStake), this.props.store) : Number(BET_LIMITS.minStake / BASE_VALUE)), 2, this.props.store.getState().vpp.systemLanguage, this.props.store.getState().vpp.systemCurrency, true));
        data = data.replace(/{maxBet}/g, getFormattedCurrency(this.props.store, (usingNonDecimalCurrency(systemCurrency) ? this._scaleNumber(Number(BET_LIMITS.maxStake), this.props.store) : Number(BET_LIMITS.maxStake / BASE_VALUE)), 2, this.props.store.getState().vpp.systemLanguage, this.props.store.getState().vpp.systemCurrency, true));
        data = data.replace(/{maxLiability}/g, getFormattedCurrency(this.props.store, (usingNonDecimalCurrency(systemCurrency) ? this._scaleNumber(Number(BET_LIMITS.maxWinnings), this.props.store) : Number(BET_LIMITS.maxWinnings / BASE_VALUE)), 2, this.props.store.getState().vpp.systemLanguage, this.props.store.getState().vpp.systemCurrency, true));
        data = data.replace(/{vppVersion}/g, process.env.NODE_ENV !== 'development' ? BMS.vppVersion : 'Unknown');
        data = data.replaceAll(/{displayEachWay}/g, OPERATOR.disabledMarkets.toUpperCase().includes(TO_WIN_EW.name) ? 'display:none' : '');
        data = this._disableRacingMarkets(data);
        data = this._disableContentForUnavailableChannels(data);
        return data;
    }

    _scaleNumber(number, store) {
        if (usingNonDecimalCurrency(store.getState().vpp.systemCurrency)) {
            return number;
        } else {
            return number / 100;
        }
    }

    componentDidUpdate() {
        this._extraPaddingForBookmark();
    }

    _scrollHandler(event) {
        if (!this.state.isScrollTopButtonVisible && event.target.scrollTop > 100) {
            this.setState({isScrollTopButtonVisible: true});
        } else if (this.state.isScrollTopButtonVisible && event.target.scrollTop <= 100) {
            this.setState({isScrollTopButtonVisible: false});
        }
    }

    _leftArrowClickHandler() {
        if (this.state.pageSelectedIndex > 0) {
            this._navigationPageClickHandler(this.state.pageSelectedIndex - 1);
        }
    }

    _rightArrowClickHandler() {
        if (this.state.pageSelectedIndex < this.state.pagesJson.fileNames.length - 1) {
            this._navigationPageClickHandler(this.state.pageSelectedIndex + 1);
        }
    }

    _disableRacingMarkets(data) {
        let displayEachWay = false;
        let displayPlace = false;
        let displayShow = false;
        let disabledMarkets = OPERATOR.disabledMarkets ? JSON.parse(OPERATOR.disabledMarkets) : [];

        VIRTUALS.filter(game => game.type === 'racing').forEach(game => {
            let supportedMarkets = SUPPORTED_RACING_MARKETS[game.UID];
            let disabledGame = disabledMarkets.find(disbledGame => disbledGame.channel === game.channel);
            if (!disabledGame || !disabledGame.disabledMarkets || supportedMarkets.length !== disabledGame.disabledMarkets.length) {
                if (!displayEachWay && supportedMarkets.includes(TO_WIN_EW.name) &&
                    (!disabledGame || !disabledGame.disabledMarkets || !disabledGame.disabledMarkets.includes(TO_WIN_EW.name))) {
                    displayEachWay = true;
                    data = data.replace(/{displayEachWay}/g, 'display:block;');
                } else if (!displayPlace && supportedMarkets.includes(PLACE.name) &&
                    (!disabledGame || !disabledGame.disabledMarkets || !disabledGame.disabledMarkets.includes(PLACE.name))) {
                    displayPlace = true;
                    data = data.replace(/{displayPlace}/g, 'display:block;');
                } else if (!displayShow && supportedMarkets.includes(SHOW.name) &&
                    (!disabledGame || !disabledGame.disabledMarkets || !disabledGame.disabledMarkets.includes(SHOW.name))) {
                    displayShow = true;
                    data = data.replace(/{displayShow}/g, 'display:block;');
                }

            }
            supportedMarkets.forEach(supportedMarket => {
                let flag = '{' + game.channel + "_" + supportedMarket + '}';
                if (!disabledGame || !disabledGame.disabledMarkets || !disabledGame.disabledMarkets.includes(supportedMarket)) {
                    data = data.replace(new RegExp(flag, "g"), 'display:table-row');
                } else {
                    data = data.replace(new RegExp(flag, "g"), '');
                }
            });

        });
        if (!displayEachWay)
            data = data.replace(/{displayEachWay}/g, 'display:none;');
        if (!displayPlace)
            data = data.replace(/{displayPlace}/g, 'display:none;');
        if (!displayShow)
            data = data.replace(/{displayShow}/g, 'display:none;');
        return data;
    }

    _extraPaddingForBookmark() {
        try {
            let elements = document.getElementsByTagName('a');
            if (elements && elements.length > 0) {
                for (let i = 0; i < elements.length; i++) {
                    let href = elements[i].getAttribute("href");
                    if (href && href.startsWith('#')) {
                        let element = document.getElementsByName(href.replace('#', ''));
                        if (element && element.length > 0)
                            element[0].setAttribute("style", "padding-top:10px");
                    }
                }
            }
        } catch (e) {
            console.warn('Error Occured While adding style to bookmarks.');
        }
    }

    _disableContentForUnavailableChannels(data) {
        // Loop through all channels to activate content for available channels.
        VIRTUALS.forEach(function (channel) {
            // Game Types
            data = data.replace(new RegExp('{displayGameType_' + channel.type + '}', 'g'), '');
            // Categories
            data = data.replace(new RegExp('{displayCategory' + channel.category.name.replaceAll(' ', '_') + '}', 'g'), '');
            // Channels - here we need to respect the fact that there can be more than 1 instance configured for a channel. This situation is manifested
            // with more than 1 channel with the same base name, but the name ends with a number. For example, VPP_Basketball_USA1 and VPP_Basketball_USA2. 
            // The help pages may contain content for the base channel name, as well as the numbered channel name. Even though we haven't explicitly configured
            // the base channel name, help page content can still exist for it.
            var channelNumberRegex = /[0-9]/g;
            channelNumberRegex.test(channel.channel);
            data = data.replace(new RegExp('{displayChannel' + channel.channel.substring(0, channelNumberRegex.lastIndex - 1) + '}', 'g'), '');
            data = data.replace(new RegExp('{displayChannel' + channel.channel + '}', 'g'), '');
        });

        // Disable content for unavailable channels.
        data = data.replace(/{displayGameType_.*}/g, 'display:none;');
        data = data.replace(/{displayCategory.*}/g, 'display:none;');
        data = data.replace(/{displayChannel.*}/g, 'display:none;');

        return data;
    }

    render() {
        let page = (<div></div>)
        if (this.state.pagesJson !== undefined && this.state.pagesJson.fileNames.length > 0) {
            page = (<div className={style.helpPageDocument} dangerouslySetInnerHTML={{__html: this.state.pageHtml}}/>);
        }

        let scrollTopButtonClass = this.state.isScrollTopButtonVisible ?
            `${style.scrollTopButton} ${style.show}`
            : style.scrollTopButton
        let scrollTopButton = (
            <div className={scrollTopButtonClass} onClick={() => this._scrollTopButtonClickHandler()}>
                <img className={style.arrowImage} src={`${ASSETS_URL}next.svg`} alt='next'/>
            </div>);

        return (
            <div className={style.help}>
                <div id={helpContentId} className={style.content}>
                    {page}
                </div>
                {scrollTopButton}
                {/*<div className={style.pagination}>*/}
                {/*{leftArrow}*/}
                {/*{pages}*/}
                {/*{rightArrow}*/}
                {/*</div>*/}
            </div>
        );
    }
}

export default connect(mapStateToProps)(HelpPageScreen);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/helpPageScreen.js